export const SET_MINI_BRANDING = 'SET_MINI_BRANDING'
